/**
 * When framed in Puter desktop (grudge-poker), offer open full poker host for
 * stable Phantom inject / Google-Apple OAuth. Dismissible for browsing lobby.
 */
import { useEffect, useState } from "react";
import { ExternalLink, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  breakoutToProduction,
  isPuterEmbed,
  PUTER_POKER,
} from "@/lib/puter-embed";

const DISMISS_KEY = "budb_puter_embed_dismiss_v1";

export function PuterEmbedBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!isPuterEmbed()) return;
    try {
      if (sessionStorage.getItem(DISMISS_KEY) === "1") return;
    } catch {
      /* ignore */
    }
    setShow(true);
  }, []);

  if (!show) return null;

  return (
    <div
      className="fixed bottom-16 left-2 right-2 z-[60] mx-auto max-w-lg rounded-xl border border-violet-500/40 bg-zinc-950/95 p-3 shadow-xl backdrop-blur sm:bottom-4 sm:left-auto sm:right-4"
      role="status"
    >
      <div className="flex items-start gap-2">
        <div className="min-w-0 flex-1 text-sm text-zinc-200">
          <p className="font-semibold text-violet-200">Puter · BUDB PKR</p>
          <p className="mt-0.5 text-xs text-zinc-400">
            Same live table as{" "}
            <span className="text-zinc-300">poker.grudge-studio.com</span>. Play
            GBUX is server D1. For Phantom Google/Apple or extension sign, open
            full window.
          </p>
          <div className="mt-2 flex flex-wrap gap-2">
            <Button
              size="sm"
              className="h-8 bg-violet-600 hover:bg-violet-500"
              onClick={() => breakoutToProduction()}
            >
              <ExternalLink className="mr-1.5 h-3.5 w-3.5" />
              Full window
            </Button>
            <Button
              size="sm"
              variant="ghost"
              className="h-8 text-zinc-400"
              onClick={() => {
                try {
                  sessionStorage.setItem(DISMISS_KEY, "1");
                } catch {
                  /* ignore */
                }
                setShow(false);
              }}
            >
              Stay in Puter
            </Button>
          </div>
          <p className="mt-1.5 truncate text-[10px] text-zinc-600">
            {PUTER_POKER.appUrl}
          </p>
        </div>
        <button
          type="button"
          className="rounded p-1 text-zinc-500 hover:bg-zinc-800 hover:text-zinc-200"
          aria-label="Dismiss"
          onClick={() => {
            try {
              sessionStorage.setItem(DISMISS_KEY, "1");
            } catch {
              /* ignore */
            }
            setShow(false);
          }}
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
